import { render, staticRenderFns } from "./myConfig.vue?vue&type=template&id=484a9833&scoped=true&"
import script from "./myConfig.vue?vue&type=script&lang=js&"
export * from "./myConfig.vue?vue&type=script&lang=js&"
import style0 from "./myConfig.vue?vue&type=style&index=0&id=484a9833&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a9833",
  null
  
)

export default component.exports